<template>
  <div class="schedule">
    <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
    <div class="schedule-con">

      <div class="flex schedule-con-info">
        <img :src="process.thumb" :onerror="Imgerror" />
        <div class="schedule-con-info-txt">
          <p class="size13 mb10"> <span class="size17 weight mr10">{{ process.status_name
      }}</span>{{ process.add_time }}</p>
          <p class="size13 mb10">{{process.goods_name}}</p>
          <p class="size13 weight Con">{{ process.question }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="graybar"></div> -->
    <div class="process-detail mary10  pad10 BGwhite">
      <div class="size16 mb5">进度详情</div>
      <p v-html="process.outcome" class="size13" style="word-break:break-all;color:#888"></p>
    </div>
    <div class="step BGwhite pady20">
      <div v-for="(item, index) in process.case_list" :key="item.name" class="step__item" :class="{ active: isActive(index) }">
        <div class="step__txt">{{ item.name }} {{ item.time }}</div>
        <div class="step__circle"></div>
      </div>
    </div>
    <div class="flex between schedule-bottom BGwhite">
      <div v-if="$route.query.type == '公示中'" @click="$router.push({ path: '/shop/accident/judgment',
        query: { order_id: $route.query.id },})">
        判决文书
      </div>
      <div :class="$route.query.type == '公示中'?'':'schedule-block'" @click="$router.push({path: '/shop/accident/complaint',
        query: { order_id: $route.query.order_id },})">查看诉呈</div>
      <!-- <router-link v-if="$route.query.type == '公示中'" :to="{
        path: '/shop/accident/judgment',
        query: { order_id: $route.query.id },
      }">判决文书</router-link>
    <router-link :to="{
        path: '/shop/accident/complaint',
        query: { order_id: $route.query.order_id },
      }"></router-link> -->
    </div>
  </div>

</template>
<script setup>
import ajax from "@/utils/request.js";
import { ref } from "vue";
import { useRoute } from "vue-router";

const { query } = useRoute();

const active = ref(0);
const process = ref({});
const isActive = (index) => {
  return active.value === index;
};
ajax.post("accident/process", { order_id: query.order_id }).then((res) => {
  process.value = res.data;
});

const next = () => {
  history.forward()
}
</script>
<style scoped>
.schedule{
  width: 100%;
  height: 100%;
  background-color: #efefef;
}
.schedule-con__tle {
  color: #333333;
  margin-top: 5.3333vw;
  padding-left: 15px;
}
.schedule-con__tle span {
  color: #999999;
}
.schedule-con-info {
  padding: 10px 15px 20px;
  align-items: flex-start;
  background-color: #fff;
}
.schedule-con-info img {
  width: 26.6667vw;
  height: 26.6667vw;
  background: #ffffff;
  border-radius: 1.0667vw;
  background-color: #999999;
}
.schedule-con-info-txt {
  padding-left: 10px;
  font-size: 12px;
  color: #333333;
}
.schedule-con-info-txt p {
  line-height: 20px;
}
.graybar {
  width: calc(100% - 30px);
  margin-left: 15px;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 20px;
}
.step {
  padding-left: 30px;
}
.step__item {
  position: relative;
  margin-bottom: 20px;
}
.step__txt {
  color: #999999;
  font-size: 14px;
}
.step__circle {
  position: absolute;
  width: 7px;
  height: 7px;
  background: #999999;
  top: 50%;
  left: -15px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.step__circle::after {
  content: "";
  width: 1px;
  position: absolute;
  height: 33px;
  top: -34px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #999999;
}
.step__item.active .step__circle {
  width: 13px;
  height: 13px;
  background: #3f7c93;
}
.step__item.active .step__txt {
  font-size: 16px;
  color: #3f7c93;
}
/* .step__item.active {
    margin-bottom: 30px;
} */
.step__item.active .step__circle::after {
  background-color: #3f7c93;
}
.step__item:first-child .step__circle::after {
  width: 0;
}
.schedule-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 15px;
}
.schedule-bottom a {
    width: 48%;
    height: 10vw;
    line-height: 10vw;
    text-align: center;
    border-radius: 4vw;
    border: 1px solid #cccccc;
    font-size: 14px;
    color: #3f7c93;
}
.schedule-bottom a:last-child {
    background-color: #3f7c93;
    color: #ffffff;
}
.schedule-bottom div {
  
    width: 48%;
    height: 10vw;
    line-height: 10vw;
    text-align: center;
    border-radius: 4vw;
    border: 1px solid #cccccc;
    font-size: 14px;
    color: #3f7c93;
}
.schedule-bottom div:last-child {
    background-color: #3f7c93;
    color: #ffffff;
}
.schedule-bottom .schedule-block{
  width: 100%;
}
</style>